import { createGlobalStyle } from 'styled-components';
import NotoSansRegular from './assets/fonts/NotoSans-Regular.ttf';
import NotoSansBold from './assets/fonts/NotoSans-Bold.ttf';
import RobotoRegular from './assets/fonts/Roboto-Regular.ttf';
import RobotoBold from './assets/fonts/Roboto-Bold.ttf';
import styled from "styled-components";
import { BaseModalBackground } from "styled-react-modal";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    src: url(${NotoSansRegular});
  }

  @font-face {
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: bold;
    src: url(${NotoSansBold});
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoRegular});
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: bold;
    src: url(${RobotoBold});
  }

  html,
  body,
  #root {
    width: 100%;
    height: 100%;
    margin: 0px;
    position: relative;
  }

  body {
    font-family: 'Noto Sans', sans-serif;
  }

  p,
  label {
    font-family: 'Noto Sans', sans-serif;
    line-height: 1.5em;
  }

  
  body h1,
  body h2,
  body h3 {
    font-family: 'Noto Sans', sans-serif;
  }

  .Toastify__toast {
    border-radius: 0.365vw !important;
  }

  .lg-outer.lg-visible {
    left: 20% !important;
    width: 80% !important;
  }
`;

export const CustomModalBackground = styled(BaseModalBackground)`
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
`;
